import React from 'react';
import {Navigation} from '../Navigation'

export const Browser = (props) => {
    return (
        <Navigation>
            <div>Browser</div>
        </Navigation>
    )
}